import { useMemo, useState } from "react";
import { hotPicks } from "@/mocks/ranking";

export default function HotPicks() {
  const [keyword, setKeyword] = useState("");
  const [tag, setTag] = useState("全部");

  const tags = useMemo(
    () => ["全部", ...Array.from(new Set(hotPicks.map((h) => h.tag)))],
    []
  );

  const filtered = useMemo(
    () =>
      hotPicks.filter((h) => {
        const matchTag = tag === "全部" || h.tag === tag;
        const kw = keyword.trim().toLowerCase();
        const matchKw =
          !kw ||
          h.title.toLowerCase().includes(kw) ||
          h.excerpt.toLowerCase().includes(kw) ||
          h.tag.toLowerCase().includes(kw);
        return matchTag && matchKw;
      }),
    [tag, keyword]
  );

  return (
    <section
      id="hot"
      className="scroll-mt-16 border-y border-background-200 bg-background-100/70 py-12 md:py-16"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-bold tracking-widest text-secondary-800">
              <i className="ri-flashlight-fill"></i>
              本日精选
            </span>
            <h2 className="mt-4 font-serif text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              热瓜速览 · 精选长文
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              每天从榜单里挑几篇值得细读的深度稿，带你看懂来龙去脉，而不是只刷到一句话标题。
            </p>
          </div>

          <form
            className="flex w-full items-center overflow-hidden rounded-full border border-background-300 bg-background-50 focus-within:border-primary-300 lg:max-w-xs"
            onSubmit={(e) => e.preventDefault()}
          >
            <span className="pl-4 text-foreground-400">
              <i className="ri-search-line"></i>
            </span>
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索你想补的课…"
              className="w-full bg-transparent px-3 py-2.5 text-sm outline-none placeholder:text-foreground-400"
              aria-label="搜索热瓜"
            />
          </form>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {tags.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setTag(t)}
              className={`rounded-full px-4 py-1.5 text-sm font-semibold whitespace-nowrap transition-colors ${
                tag === t
                  ? "bg-secondary-800 text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-700 hover:border-secondary-400"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <div className="mt-10 flex flex-col items-center gap-3 rounded-2xl border border-dashed border-background-300 bg-background-50 py-16 text-center">
            <i className="ri-ghost-line text-4xl text-foreground-300"></i>
            <p className="text-sm text-foreground-500">
              没搜到相关内容，换个关键词或切回“全部”看看吧。
            </p>
          </div>
        ) : (
          <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((card) => (
              <article
                key={card.id}
                className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
              >
                <a href="#deep" className="block overflow-hidden">
                  <div className="relative h-44 w-full overflow-hidden">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                      {card.tag}
                    </span>
                  </div>
                </a>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-serif text-lg font-bold leading-snug text-foreground-950">
                    <a href="#deep" className="hover:text-primary-700">
                      {card.title}
                    </a>
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {card.excerpt}
                  </p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-time-line"></i>
                      {card.time}
                    </span>
                    <span className="flex items-center gap-1.5 font-medium text-primary-600">
                      <i className="ri-fire-line"></i>
                      {card.read}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}